export const computeLastKnownNetwork2Busy = (incompleteRequestStarts, observedResourceRequests) => {
    if (incompleteRequestStarts.length > 2) {
        return performance.now();
    }
    const endpoints = [];
    for (const { startTime, endTime } of observedResourceRequests) {
        endpoints.push({
            timestamp: startTime,
            type: 'request-start',
        });
        endpoints.push({
            timestamp: endTime,
            type: 'request-end',
        });
    }
    for (const incompleteRequestStart of incompleteRequestStarts) {
        endpoints.push({
            timestamp: incompleteRequestStart,
            type: 'request-start',
        });
    }
    endpoints.sort((a, b) => a.timestamp - b.timestamp);
    let currentActive = incompleteRequestStarts.length;
    for (let i = endpoints.length - 1; i >= 0; i -= 1) {
        const endpoint = endpoints[i];
        switch (endpoint.type) {
            case 'request-start':
                currentActive -= 1;
                break;
            case 'request-end':
                currentActive += 1;
                if (currentActive > 2) {
                    return endpoint.timestamp;
                }
                break;
            default:
                return 0;
        }
    }
    return 0;
};
